export default "__VITE_ASSET__DqgCDYDI__"